<script setup>
const props = defineProps(['model'])

const blockComponent = computed(() => {
  const resolved = resolveComponent(props.model.component.replace('(1)', ''))
  if (typeof resolved === 'object') {
    return resolved
  }
  else {
    return null
  }
})
</script>

<template>
  <component
    :is="blockComponent"
    :model="model"
  />
</template>
